/**
 * An unknown route renders this page — never a silent redirect (#130, design.functional §6).
 * It says what happened and offers every page the user can open.
 */
import { useLocation } from 'react-router-dom';
import { ButtonLink } from '@/kit';
import { useMe } from '@/api/queries';
import { platformEntries, platformOf } from '@/app/platform';
import { useApps } from '@/features/apps/apps-api';

export function NotFound() {
  const { pathname } = useLocation();
  const me = useMe(true);
  const apps = useApps(Boolean(me.data));
  const items = platformEntries(platformOf(apps.data).entries, me.data?.roles.map((r) => r.role) ?? []);
  return (
    <div className="grid-bg flex min-h-[60vh] flex-col items-start justify-center gap-4 px-8 py-16">
      <p className="eyebrow">Page not found</p>
      <h1>There is no page here</h1>
      <p className="max-w-[72ch] text-ink-2">
        Nothing lives at <span className="id-mono text-ink">{pathname}</span>. The link may be out of date. Pick where you
        meant to go:
      </p>
      <ul className="flex flex-wrap gap-2">
        {items.map((item) => (
          <li key={item.id}>
            <ButtonLink to={item.route} variant="secondary">
              {item.label}
            </ButtonLink>
          </li>
        ))}
      </ul>
    </div>
  );
}
